// extracted by mini-css-extract-plugin
export var label = "_it-0";
export var treatmentCard = "_it-1";